/**
 * Olive.III — Eid Collection Tabs Transition Controller
 * - Smooth luxury zoom-out then zoom-in tab switching
 * - Active state toggling with accessibility support (ARIA)
 * - Auto-reinitialization of luxury product card sliders in newly active tab
 * - Shopify theme editor block select integration
 */

(function () {
  function initEidCollectionTabs() {
    var sections = document.querySelectorAll('.eid-tabs-section-wrapper:not([data-eid-tabs-initialized])');

    sections.forEach(function (section) {
      section.setAttribute('data-eid-tabs-initialized', 'true');

      var tabButtons = Array.prototype.slice.call(section.querySelectorAll('.eid-tab-btn'));
      var tabPanels = Array.prototype.slice.call(section.querySelectorAll('.eid-tab-panel'));

      if (!tabButtons.length || !tabPanels.length) return;

      var isAnimating = false;

      tabButtons.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();

          if (btn.classList.contains('active') || isAnimating) return;

          var targetSelector = btn.getAttribute('data-tab-target');
          var targetPanel = section.querySelector(targetSelector);
          var currentPanel = section.querySelector('.eid-tab-panel.active');

          if (!targetPanel || targetPanel === currentPanel) return;

          isAnimating = true;

          // 1. Update button states
          tabButtons.forEach(function (b) {
            b.classList.remove('active');
            b.setAttribute('aria-selected', 'false');
          });
          btn.classList.add('active');
          btn.setAttribute('aria-selected', 'true');

          // 2. Play zoom-out animation on outgoing panel
          if (currentPanel) {
            currentPanel.classList.add('is-leaving');
            currentPanel.classList.remove('active');
          }

          // 3. Smooth delay before zooming in new panel
          setTimeout(function () {
            if (currentPanel) {
              currentPanel.classList.remove('is-leaving');
            }

            tabPanels.forEach(function (p) {
              if (p !== targetPanel) {
                p.classList.remove('active', 'is-leaving');
              }
            });

            targetPanel.classList.add('active');

            // 4. Re-initialize luxury card slider galleries in the newly displayed tab
            if (window.initLuxuryCardSliders && typeof window.initLuxuryCardSliders === 'function') {
              window.initLuxuryCardSliders();
            }

            // Also re-trigger resize event for any image calculations
            window.dispatchEvent(new Event('resize'));

            isAnimating = false;
          }, 180);
        });
      });
    });
  }

  // Initialize on load and Shopify theme editor updates
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEidCollectionTabs);
  } else {
    initEidCollectionTabs();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initEidCollectionTabs();
  });

  document.addEventListener('shopify:block:select', function (event) {
    var blockId = event.detail.blockId;
    var btn = document.querySelector('[data-block-id="' + blockId + '"].eid-tab-btn');
    if (btn) {
      btn.click();
    }
  });
})();
